import {
  BiophilicDesignB,
  ColorPOPB,
  HeritageModernDesignB,
  JapandiThemeB,
  NeoIndustrialB,
  SoftRetroB,
  WarmIndustrialB,
} from "../assets/conceptualBg";
import { biophilicPages } from "../assets/conceptualBg/biophilic/biophilicPages";
import { colorPopPages } from "../assets/conceptualBg/colorPop/colorPopPages";
import { heritagePages } from "../assets/conceptualBg/heritage/heritagePages";
import { japandiPages } from "../assets/conceptualBg/japandi/japandiPages";
import { neoPages } from "../assets/conceptualBg/neo/neoPages";
import { softRetroPages } from "../assets/conceptualBg/softRetro/softRetroPages";
import { warmPages } from "../assets/conceptualBg/warm/warmPages";

import {
  LargeBiophilicDesig,
  LargeColorPO,
  LargeHeritageModernDesig,
  LargeJapandiThem,
  LargeNeoIndustria,
  LargeSoftRetr,
  LargeWarmIndustria,
} from "../assets/conceptualSlide/extraLarge";

export const zones = [
  "Reception",
  "Meeting Room",
  "Board Room",
  "Breakout Area",
  "CEO Cabin",
  "Cafeteria",
  "Manager Cabin",
  "Open Office",
  "Pantry",
  "Washroom",
  // "Y"
];

export const sections = [
  "Walls",
  "Flooring",
  "Lighting",
  "Furniture",
  "Decorative",
  "Ceiling",
];

export const Materials = [
  "Paint",
  "Acoustic Panels",
  "Wallpaper",
  "Wall Panel",
  "Porcelain Tiles",
  "Marble",
  "Wooden Tile",
  "Carpet Tiles",
  "LVT",
  "Decorative Light",
  "Ambient Light",
  "Task Light",
  "Panel Light",
  "Wall Light",
  "Wood (for desks)",
  "Reception Table",
  "Sofa",
  "Centre Table",
  "Lounge Chair",
  "Glass Film",
  "Planter",
  "Frames",
  "Grid Ceiling",
  "Baffle Ceiling",
  "Acoustic Ceiling",
  "Gypsum Ceiling",
  "Laminate Ceiling",
  "Wooden Tiles",

  "Wall  Light",
  "Workstation Table",
  "Upholstered Chairs",
  "Storage Low & High",
  "Comfortable Chairs",
  "Pedestal",
  "Ambient Lighting",
  "Wall Light",
  "Meeting Tables",
  "SPC",
  "Boardroom Tables",
  "Vinyl",
  "Wood (for Center Table etc)",
  "Soft Sitting",
  "Lounge Chairs",
  "Armchair",
  "Cabin Desk",
  "Metal for tables",
  "High Back Chair",
  "High Table",
  "Pantry Chair",
];

export const Maintainance = ["N/A", "Monthly", "Quarterly", "Yearly"];

export const designStyle = [
  {
    name: "Warm Industrial",
    slide: LargeWarmIndustria,
    slide_Tab: LargeWarmIndustria,
    slide_Mob: LargeWarmIndustria,
    slide_ExtraLarge: LargeWarmIndustria,
    bg: WarmIndustrialB, // no use
    bgArray: warmPages,
  },
  {
    name: "Soft Retro Mid-Century Revivals",
    slide: LargeSoftRetr,
    slide_Tab: LargeSoftRetr,
    slide_Mob: LargeSoftRetr,
    slide_ExtraLarge: LargeSoftRetr,
    bg: SoftRetroB,
    bgArray: softRetroPages,
  },
  {
    name: "Japandi Theme",
    slide: LargeJapandiThem,
    slide_Tab: LargeJapandiThem,
    slide_Mob: LargeJapandiThem,
    slide_ExtraLarge: LargeJapandiThem,
    bg: JapandiThemeB,
    bgArray: japandiPages,
  },
  {
    name: "Neo Industrial",
    slide: LargeNeoIndustria,
    slide_Tab: LargeNeoIndustria,
    slide_Mob: LargeNeoIndustria,
    slide_ExtraLarge: LargeNeoIndustria,
    bg: NeoIndustrialB,
    bgArray: neoPages,
  },
  {
    name: "Color Pop",
    slide: LargeColorPO,
    slide_Tab: LargeColorPO,
    slide_Mob: LargeColorPO,
    slide_ExtraLarge: LargeColorPO,
    bg: ColorPOPB,
    bgArray: colorPopPages,
  },
  {
    name: "Biophilic Design",
    slide: LargeBiophilicDesig,
    slide_Tab: LargeBiophilicDesig,
    slide_Mob: LargeBiophilicDesig,
    slide_ExtraLarge: LargeBiophilicDesig,
    bg: BiophilicDesignB,
    bgArray: biophilicPages,
  },
  {
    name: "Heritage Modern Design",
    slide: LargeHeritageModernDesig,
    slide_Tab: LargeHeritageModernDesig,
    slide_Mob: LargeHeritageModernDesig,
    slide_ExtraLarge: LargeHeritageModernDesig,
    bg: HeritageModernDesignB,
    bgArray: heritagePages,
  },
];

export const areaDescription = {
  Materials:
    "A curated collection of premium finishes, surfaces, and fittings that define the look and feel of every space. Designed to align aesthetics with durability and functionality. Airbrick provides high-quality materials that are carefully sourced and seamlessly installed on-site for long-lasting impact.",

  "open office":
    "A modern collaborative environment that promotes transparency and teamwork. Encourages innovation while maximizing space efficiency. Airbrick’s open layouts combine ergonomic planning with contemporary design for seamless collaboration.",

  "private office":
    "Enclosed workspaces that offer complete privacy and focus. Perfect for professionals who value discretion, productivity, and comfort. Airbrick brings sophistication and smart detailing to create truly inspiring private offices.",

  "work lounge":
    "A stylish, flexible space blending comfort with functionality. Ideal for informal meetings, solo tasks, or creative recharging throughout the day. Airbrick designs elevate lounges with a blend of comfort-driven furniture and elegant finishes.",

  assembly:
    "A versatile gathering space for large teams, events, and presentations. Designed to handle high-impact sessions and bring people together. Airbrick ensures these spaces are both functional and visually striking for memorable experiences.",

  boardroom:
    "A premium executive space that reflects professionalism and authority. Tailored for strategic decisions, client presentations, and leadership discussions. Airbrick boardrooms integrate timeless design with modern functionality to impress at every level.",

  "brainstorm room":
    "An inspiring, creative hub built to spark innovation. Encourages dynamic teamwork and idea generation in an energizing environment. Airbrick incorporates adaptive layouts and vibrant aesthetics to keep creativity flowing.",

  "breakout space":
    "Casual yet functional areas designed for short breaks and informal exchanges. Helps refresh minds while boosting team interaction. Airbrick’s breakout spaces are designed with warmth and vibrancy to spark organic connections.",

  "large meeting room":
    "Spacious, professional, and fully equipped for group collaborations. A setting where big ideas and impactful conversations thrive. Airbrick meeting rooms fuse cutting-edge design with comfort for powerful engagements.",

  "large open meeting space":
    "A flexible, open-format zone designed for collaborative discussions. Perfect for workshops, networking, and interactive sessions. Airbrick designs maximize openness while maintaining balance through elegant detailing.",

  "small meeting room":
    "Compact yet private rooms that ensure focus and clarity. Ideal for one-on-one meetings, interviews, or quick decision-making. Airbrick creates intimate spaces that feel professional yet comfortable.",

  "small open meeting space":
    "Flexible open spots that encourage spontaneous conversations. Great for quick team huddles and informal discussions. Airbrick integrates clean lines and smart layouts to make even small spaces impactful.",

  "training room":
    "Purpose-built for workshops, seminars, and skill development. A modern environment to drive learning, collaboration, and growth. Airbrick’s training rooms balance durability with engaging design to inspire continuous learning.",

  bar: "A vibrant, social hub designed for relaxation and networking. Encourages stronger workplace culture through informal interactions. Airbrick infuses its design expertise to create bars that are lively, modern, and welcoming.",

  cafeteria:
    "A welcoming dining area for meals, conversations, and recharging. Supports employee wellness and builds community beyond work. Airbrick cafeterias are crafted to merge comfort, efficiency, and contemporary appeal.",

  "elevator lobby":
    "A sleek transition space that sets the tone for the workplace. Creates a professional, welcoming first impression at every level. Airbrick designs these lobbies with striking finishes that leave a lasting impression.",

  "games room":
    "A recreational escape that helps employees recharge. Builds camaraderie and keeps workplace energy high. Airbrick creates vibrant, playful spaces that boost morale while maintaining modern style.",

  "locker area":
    "Secure, personal storage that provides convenience and peace of mind. Designed to support a clutter-free and organized workplace. Airbrick integrates sleek design with practicality to make storage seamless and stylish.",

  "pantry area":
    "A refreshment zone for coffee, snacks, and quick team connections. Encourages casual interactions while keeping energy levels up. Airbrick pantries are designed with smart layouts and inviting aesthetics.",

  "phone study booth":
    "Enclosed booths offering quiet and privacy for calls or focused work. Ensures productivity without distractions. Airbrick designs these booths with acoustic comfort and minimal elegance.",

  "reception waiting area":
    "A professional, welcoming space for visitors and clients. Sets a strong first impression while ensuring guest comfort. Airbrick receptions balance hospitality with sophistication for a memorable arrival experience.",

  restroom:
    "Clean, hygienic, and well-maintained facilities. Designed with user comfort and accessibility in mind. Airbrick restrooms emphasize both functionality and refined modern finishes.",
};

export const zonesWithProducts = [
  {
    zone: "Reception",
    products: [
      { name: "Mangas Natural", brand: "Haworth India" },
      { name: "Keystone", brand: "Haworth India" },
      { name: "Nawabari", brand: "Haworth India" },
      { name: "Diagonales", brand: "Haworth India" },
      // {
      //   name: "Ankur Lighting ARBLE MODERN ACRYLIC FLOOR LAMP",
      //   brand: "Ankur Lighting",
      // },
    ],
  },
  {
    zone: "Meeting Room",
    products: [
      { name: "Mystique White Mid Back Chair", brand: "Ergo Space" },
      { name: "Torino", brand: "Haworth India" },
      { name: "BuzziMoon", brand: "Haworth India" },
      { name: "crona conference chair", brand: "Haworth India" },
    ],
  },
  {
    zone: "Board Room",
    products: [
      {
        name: "LED Streek Tracklight 20 W 4000 K BLK",
        brand: "Havells Lighting",
      },
      {
        name: "ANKUR GEOM TANGLED CONTEMPORARY LED PENDANT CHANDELIER",
        brand: "Ankur Lighting",
      },
      { name: "A-Bench", brand: "Haworth India" },
      {
        name: "Philips Divine 15 head Chandelier",
        brand: "Philips Lighting",
      },
    ],
  },
  {
    zone: "Breakout Area",
    products: [
      { name: "Atom", brand: "Haworth India" },
      { name: "Park Pod", brand: "Haworth India" },
      { name: "STRISCE COFFEE", brand: "H & R Johnson (Johnson Tiles)" },
      {
        name: "ANKUR ARLO DOUBLE ROPE HANGING LIGHT",
        brand: "Ankur Lighting",
      },
    ],
  },
  {
    zone: "CEO Cabin",
    products: [
      { name: "Brezza", brand: "Haworth India" },
      { name: "Mama Bear", brand: "Haworth India" },
      {
        name: "Prism Twist Cob LED Downlighter Round",
        brand: "Orient Electric",
      },
      { name: "Fern Executive", brand: "Haworth India" },
    ],
  },
  {
    zone: "Cafeteria",
    products: [
      { name: "BuzziMilk", brand: "Haworth India" },
      { name: "Bodyline Visitor Chair", brand: "Featherlite" },
      { name: "Mais Cafe Chair", brand: "Featherlite" },
      { name: "Mojito Bar Chair", brand: "Featherlite" },
    ],
  },
  {
    zone: "Manager Cabin",
    products: [
      { name: "BuzziBooth", brand: "Haworth India" },
      { name: "Hostel Book Shelf", brand: "Featherlite" },
      {
        name: "ANKUR ORBIT SURFACE MOUNTED INDOOR DOWNLIGHT FOR HOME AND OFFICES",
        brand: "Ankur Lighting",
      },
      { name: "Active Components™", brand: "Haworth India" },
    ],
  },
  {
    zone: "Open Office",
    products: [
      { name: "Hemm", brand: "Haworth India" },
      { name: "HushFree.Access.L", brand: "Haworth India" },
      { name: "Planes", brand: "Haworth India" },
      { name: "Yourway Worktools", brand: "Haworth India" },
    ],
  },
  {
    zone: "Pantry",
    products: [
      { name: "fox bar", brand: "Haworth India" },
      { name: "Smoke", brand: "Haworth India" },
      { name: "Naval Club-N", brand: "Asian Paints" },
      { name: "Metal Benches", brand: "Featherlite" },
    ],
  },
  {
    zone: "Washroom",
    products: [
      { name: "CROSSBRIC SLATE", brand: "H & R Johnson (Johnson Tiles)" },
      { name: "WALL HUNG INTEGRATED BASIN", brand: "Jaquar" },
      { name: "CRUST MONTE", brand: "H & R Johnson (Johnson Tiles)" },
      { name: "PLAIN IVORY", brand: "H & R Johnson (Johnson Tiles)" },
    ],
  },
];
